var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-links"},_vm._l((_vm.logoLinks),function(link,index){return _c('a',{key:'link-' + index,staticClass:"logo-link"},[(link.image)?_c('img',{attrs:{"src":link.image,"alt":link.alt}}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }